<form [formGroup]="internalFormGroup">
  <digires-state-indicator [formCtrlName]="formCtrlName"
                           [readOnly]="readOnly"
                           [readOnlyReason]="readOnlyReason"
                           [finModel]="finModel"
  ></digires-state-indicator>
  <mat-form-field *ngIf="readOnly" [ngClass]="{changed:isDirty()}">
    <mat-label>{{placeholder}}</mat-label>
    <label >
      <input matInput
             type="text"
             readonly
             [value]="getReadonlyValue()"/>
    </label>
    <mat-error *ngIf="error">
      {{error}}
    </mat-error>
    <mat-error *ngFor="let err of getErrorMessages()">
      {{err}}
    </mat-error>
  </mat-form-field>
  <mat-form-field *ngIf="!readOnly" [ngClass]="{changed:isDirty()}">
    <mat-label>{{placeholder}}</mat-label>
    <mat-select [required]="required && !readOnly"
                [multiple]="true"
                formControlName="multiSelect"
                disableOptionCentering
                panelClass="mat-dropdown-panel-override"
                (selectionChange)="onItemSelected($event)">
      <mat-option *ngIf="noItemName" [value]="NO_ITEMS">{{noItemName}}</mat-option>
      <mat-option *ngIf="allItemName" [value]="ALL_ITEMS">{{allItemName}}</mat-option>

      <mat-optgroup *ngFor="let group of groups" [label]="group.label">
        <mat-option *ngFor="let item of group.items" [value]="itemToId(item)" [title]="itemToLabel(item)" matTooltip="{{itemToLabel(item)}}">
          {{itemToLabel(item)}}
        </mat-option>
      </mat-optgroup>
    </mat-select>

    <mat-error *ngIf="error">
      {{error}}
    </mat-error>
    <mat-error *ngFor="let err of getErrorMessages()">
      {{err}}
    </mat-error>
  </mat-form-field>
  <mat-icon *ngIf="!!tooltip" class="tooltip-icon" matTooltipPosition="above" matTooltip="{{tooltip}}" svgIcon="tooltip"></mat-icon>
  <mat-icon *ngIf="finModel?.isReadable(formCtrlName)" class="warning-triangle"
            [class.transparent]="!finModel.hasUpload || finModel.isRead(formCtrlName)"
            matTooltip="Note: The value in this field was not populated by the most recent upload of the financial model">
    warning
  </mat-icon>
</form>
